module.exports = __webpack_public_path__ + "static/media/ajay-chaturvedi.08e6d60b.jpg";